const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function request(path, options = {}) {
  const response = await fetch(`${BACKEND_URL}/api/v1/takehome/${path}`, {
    ...options,
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = data.detail;
    const shaped = typeof detail === 'object' && detail ? detail : data;
    const message = typeof detail === 'string'
      ? detail : shaped.detail || shaped.code || `Take-home request failed: ${response.status}`;
    const error = new Error(message);
    Object.assign(error, data, shaped, { status: response.status });
    throw error;
  }
  return data;
}

export const getPublicTakeHome = (token) => request(encodeURIComponent(token));
export const savePublicTakeHomeFeedback = (token, value) => request(`${encodeURIComponent(token)}/feedback`, {
  method: 'POST', body: JSON.stringify(value),
});
